import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SharedUserContextModule, UserContextConfigurationToken } from '@backbase/shared/feature/user-context';
import { environment } from '../../environments/environment';
import { UserContextComponent } from './user-context.component';
import { SelectContextModule } from '@backbase/select-context';

@NgModule({
  declarations: [UserContextComponent],
  imports: [
    CommonModule,
    SharedUserContextModule,
    SelectContextModule,
    RouterModule.forChild([
      {
        path: '',
        component: UserContextComponent,
      },
    ]),
  ],
  providers: [
    {
      provide: UserContextConfigurationToken,
      useValue: environment.landingPageUrl,
    },
  ],
})
export class UserContextModule { }
